import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { Col, Row, } from "react-bootstrap";
import debounce from "lodash/debounce";
import { NotificationManager } from "react-notifications";
import HandleError from "../../../services/HandleError"; 
import SystemSettingsService from "../../../services/SystemSettingsService";
import LoaderInline from "../../helpers/LoaderInline";

class SystemSettingsPage extends Component {
	state = { response: "" }

	handleClick = (route,stateVariable) => {
		this.setState({ [stateVariable]: true });
		this.systemSettingsService.fix(route).then((res) => {
			this.setState({ [stateVariable]: false, response: res.data });
		}).catch((err) => {
			this.setState({ [stateVariable]: false });
			HandleError(err, this);
		});;
	}

	systemSettingsService = new SystemSettingsService(this);
	
	render() {  
    	const loader = <LoaderInline width="18" height="18" color="#fff"/>;
    	return (
    		<div className="crud-page system-settings-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">System settings</h2>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border system-settings-card fadeInLoadUp">
    					<Row>
    						<Col md={3} sm={6} xs={12}>
    							<h5>Check actions</h5>
    							<ul className="buttons-list">
    								{/* <LoaderInline width="20" height="20" color="#fff"/> */}
    								<li><button className="btn btn-crud btn-primary" onClick={()=>this.handleClick("check-customers-areas", "areasNoPrice")}>{this.state.areasNoPrice ? loader : "Check if customer areas have no price"}</button></li>
    								<li><button className="btn btn-crud btn-primary"  onClick={()=>this.handleClick("check-users-salary","usersWithoutSalaries")}>{this.state.usersWithoutSalaries ? loader : "Check users without salaries" }</button></li>
    								<li><button className="btn btn-crud btn-primary"  onClick={()=>this.handleClick("check-logs-costs","logsWithoutCosts")}>{this.state.logsWithoutCosts ? loader : "Check logs without costs"}</button></li>
    								<li><button className="btn btn-crud btn-primary"  onClick={()=>this.handleClick("check-tasks-costs","tasksWithoutCosts")}>{this.state.tasksWithoutCosts ? loader : "Check Tasks without costs"}</button></li>
    								<li><button className="btn btn-crud btn-primary"  onClick={()=>this.handleClick("check-project-costs","projectWithoutCosts")}>{this.state.projectWithoutCosts ? loader : "Check project without costs"}</button></li>
    							</ul>
    						</Col>

    						<Col md={3} sm={6} xs={12}>
    							<h5>Fix actions</h5>
    							<ul className="buttons-list">
    								<li><button className="btn btn-crud btn-success" onClick={()=>this.handleClick("fix-users-table","fixUsersTable")}>{this.state.fixUsersTable ? loader : "Fix users table"}</button></li>
    								<li><button className="btn btn-crud btn-success" onClick={()=>this.handleClick("fix-project-dates","fixProjectDates")}> {this.state.fixProjectDates ? loader : "Fix project dates"}</button></li>
    								<li><button className="btn btn-crud btn-success" onClick={()=>this.handleClick("fix-tasks-dates","fixTasksDates")}>{this.state.fixTasksDates ? loader : "Fix tasks date"}</button></li>
    								<li><button className="btn btn-crud btn-success" onClick={()=>this.handleClick("fix-logs-dates","fixLogsDates")}>{ this.state.fixLogsDates ? loader : "Fix logs date"}</button></li>
    							</ul>
    						</Col>
    					</Row>

    					<Row>
    						<Col md={12}>
    							<div className="results-container">
    								<label htmlFor="results">Results</label>
    								<textarea value={this.state.response} name="results" id="results" className="form-control" cols="30" rows="20" disabled />
    							</div>
    						</Col>
    					</Row>
    				</div>   
    			</div>
    		</div>
    	);
	}
}

export default SystemSettingsPage;




// WEBPACK FOOTER //
// ./src/components/pages/system-settings/SystemSettingsPage.js